import { useNavigate } from 'react-router-dom';

export function useNavigation() {
  const navigate = useNavigate();

  return {
    goHome: () => navigate('/'),
    goToGame: (level?: number) => {
      const path = level !== undefined ? `/game?level=${level}` : '/game';
      navigate(path);
    },
    goToShop: () => navigate('/shop'),
    goToLevelSelect: () => navigate('/levels'),
    goToProfile: () => navigate('/profile'),
    goToSettings: () => navigate('/settings'),
    navigate,
  };
}
